// extracted by mini-css-extract-plugin
module.exports = {"title":"nouveautes-catalogue-component_title__2M3NL"};